import React from "react";
import styles from "./ProfileMenu.module.scss";
import { connect } from "react-redux";
import { logout, openMainModal } from "../../../store/actions";
import { motion } from "framer-motion";
import { useHistory } from "react-router-dom";

const ProfileMenu = ({openMainModal, userData, ...props}) => {
  const history = useHistory();

  const handleCloseSesion = () => {
    openMainModal({
      title: "¿Deseas cerrar la sesión activa?",
      body: "Dejaran de llegarte las notificaciones de actividad.",
      isSuccess: false,
      confirmHandler: () => props.logout(true, history),
    });
  };

  const handleRedirect = () => {
    const userName = userData.type === "COMPANY" ? userData.razon_social : userData.name + " " + userData.last_name;
    history.push(`/comunidad-edify/${userData.id}/${userName}`)
  }

  return (
    <motion.div
      initial={{ y: -400 }}
      animate={{ y: 0 }}
      exit={{ y: -400 }}
      className={styles.navContainer}
    >
      <div className={styles.menuContainer}>
        <div className={styles.menuItem} onClick={() => handleRedirect()}>
          Mi Perfil
        </div>
        <div className={styles.menuItem} onClick={() => handleCloseSesion()}>
          Cerrar sesión
        </div>
      </div>
    </motion.div>
  );
};

const mapStateToProps = (state) => {
  return {
    active: state.general.compActive,
    userData: state.general.userData,
  };
};

export default connect(mapStateToProps, { logout, openMainModal })(ProfileMenu);
